import * as actionTypes from './actionTypes.js';
import axios from '../../axios-orders.js';

export const itemHandler = (ingredient, value) =>{
  return {
    type: actionTypes.ITEM_HANDLER,
    ingredient: ingredient,
    value: value
  }
}

export const  isPurchasable = () =>{
  return {
    type: actionTypes.is_PURCHASABLE,
  }
}

export const setIngredients = (ingredients, error) =>{
  return {
    type: actionTypes.SET_INGREDIENTS,
    ingredients: ingredients,
    ingredientsError: error,
  }
}

export const noIngredients = () =>{
  return{
    type: actionTypes.NO_INGREDIENTS
  }
}
export const initIngredients = () =>{
  return dispatch =>{
    axios.get('/ingredients.json')
            .then(response => {
                return dispatch(setIngredients(response.data))
            })
            .catch(err => {
                return dispatch(noIngredients())
            })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/BurgerBuilder.js